module.exports = __webpack_public_path__ + "img/radio.c7600473.svg";